import * as ActionTypes from "../../actions";
var userRows = function userRows() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_USERS_SUCCESS:
      state = [];
      if (action.response._embedded) state.push.apply(state, action.response._embedded.users);
      return state;
    case ActionTypes.POST_USER_SUCCESS:
      var embedded = action.response._embedded;
      return embedded ? state.map(function (user) {
        return user.id === embedded.id ? embedded : user;
      }) : state;
    default:
      return state;
  }
};
export default userRows;